import React, {memo} from "react"
import {Bar} from "react-chartjs-2"
import {useHistory} from "react-router-dom"
import {onClickHandler} from "../../../utils/onclick"
import {barOptions} from "../settings/options"
import {useLocalization} from "../../../hooks/localization"
import useChartLoader from "../hooks/chart-loader"
import {ChartData} from "chart.js"
import { useSelector } from "react-redux"
import fullscreen from "../../../assets/images/icons/fullscreen.png"

type Props = {
    amountStatus: (order: number) => void
    label: string
    data: ChartData<any>
    page: number
}
export const BarChart = memo(function BarChart({label, amountStatus, data, page}: Props) {
    const history = useHistory()
    const {t} = useLocalization()
    const energyControlList = useSelector(state => state.control.energyState)
    const {isLoaded, loading} = useChartLoader()
    const maxValue = Number(energyControlList.max_point)
    return (
        <div className="energy-box">
            {loading && (
                <div className="chart-spin-container">
                    <div className="chart-spin" />
                </div>
            )}
            <span style={isLoaded}>
                <span>
                    {t("energy_page.amount_chart")}&nbsp;<small>(kW/h)</small>
                </span>
                <span>
                    <button
                        {...onClickHandler(() => amountStatus(1))}
                        className={`${label === "hour" ? "energy-active-button" : ""}`}
                    >
                        {t("energy_page.hour")}
                    </button>
                    <button
                        {...onClickHandler(() => amountStatus(2))}
                        className={`${label === "day" ? "energy-active-button" : ""}`}
                    >
                        {t("energy_page.day")}
                    </button>
                    <button
                        {...onClickHandler(() => amountStatus(3))}
                        className={`${label === "month" ? "energy-active-button" : ""}`}
                    >
                        {t("energy_page.month")}
                    </button>
                    <img className="energy-fullscreen" src={fullscreen} alt="" onClick={() => history.push(`/energy/${page}`)}/>
                </span>
            </span>
            <div
                className="energy-page"
                style={{height: "180px", ...isLoaded}}
                onDoubleClick={() => history.push(`/energy/${page}`)}
            >
                <Bar data={data} options={barOptions()} />
            </div>
        </div>
    )
})
